import * as Yup from 'yup';

import CONSTANTS from '~/server_shared/generated-types/CONSTANTS';

/**
 * Range constraint shared by every form that writes the six authority-limit fields
 * (`indemnity_*` / `expenses_*` / `reserves_limit` / `payments_limit`).
 *
 * Those columns are Postgres int4 and `-1` encodes "unlimited", so the valid domain is the integers
 * in `[-1, POSTGRES_INT4_MAX]`. The server rejects anything outside it with a 400; validating here
 * too turns that round-trip into an inline field error.
 *
 * Requiredness differs per form, so callers chain their own `.required()` / `.nullable()`.
 */
export const AUTHORITY_LIMIT_SCHEMA = Yup.number()
  .integer('Must be a whole number')
  .min(-1, 'Must be -1 (unlimited) or greater')
  .max(CONSTANTS.POSTGRES_INT4_MAX, `Must be at most ${CONSTANTS.POSTGRES_INT4_MAX}`);
